import { Button, CssBaseline, Grid, Modal, Paper, Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { ClearOutlined } from '@material-ui/icons';
import NotificationsIcon from '@material-ui/icons/Notifications';
import axios from 'axios';
import { FunctionComponent, useEffect, useState } from 'react';


const useStyles = makeStyles((theme) => ({
    root: {
        height: '100vh',
    },
    image: {
        backgroundImage: 'url(/assets/img/auth-bg.jpg)',
        backgroundRepeat: 'no-repeat',
        backgroundColor:
            theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    paper: {
        margin: theme.spacing(8, 4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    logoWrapper: {
        position: 'relative',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        marginBottom: theme.spacing(3),
    },
    notiIcon: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1),
    },
    // blink: {
    //     position: 'relative',
    //     animation: '$swing 2.0s infinite ease-in-out',
    //     '&::after': {
    //         content: '""',
    //         position: 'absolute',
    //         top: -2,
    //         left: -2,
    //         right: -2,
    //         bottom: -2,
    //         borderRadius: '100%',
    //         border: '1px solid rgba(245, 0, 87, 0.5)', // soft pink
    //         animation: '$pulse 2.0s infinite ease-in-out',
    //     },

    // },
    dot: {
        position: 'relative',
        '&::after': {
            content: '""',
            position: 'absolute',
            top: 13,
            right: 12,
            width: 10,
            height: 10,
            backgroundColor: 'red',
            borderRadius: '50%',
            zIndex: 1,
        },
    },
    '@keyframes swing': {
        '0%': { transform: 'translateX(0)' },
        '25%': { transform: 'translateX(-3px)' },
        '50%': { transform: 'translateX(3px)' },
        '75%': { transform: 'translateX(-3px)' },
        '100%': { transform: 'translateX(0)' },
    },
    '@keyframes pulse': {
        '0%': {
            transform: 'scale(0.95)',
            opacity: 1,
        },
        '70%': {
            transform: 'scale(1.3)',
            opacity: 0,
        },
        '100%': {
            transform: 'scale(0.95)',
            opacity: 0,
        },
    },
    notiDot: {
        position: 'absolute',
        top: 6,
        right: 6,
        display: 'block',
        height: 2,
        width: 2,
        borderRadius: '50%',
        backgroundColor: '#ef4444',
        boxShadow: '0 0 0 2px #fff',
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalBody: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

interface AuthSehllProps {
}

export const AuthShell: FunctionComponent<AuthSehllProps> = ({ children }) => {
    const classes = useStyles();
    const [hasNewNotice, setHasNewNotice] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        fetchNotiStatus();
    }, []);

    const fetchNotiStatus = async () => {
        try {
            const res = await axios.get('/api/noti/has-noti');
            if (res.data?.data?.hasNoti) {
                setHasNewNotice(true);
            }
        } catch (err) {
            console.error('Error fetching notice status:', err);
        }
    };

    return (
        <Grid container component="main" className={classes.root} style={{ backgroundColor: "#e0f4ff" }}>
            <CssBaseline />
            <Grid item xs={false} sm={4} md={7} className={classes.image} />
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square style={{ backgroundColor: "#e0f4ff" }}>
                <div className={classes.paper}>
                    {/* Logo and Notification Icon */}
                    <div className={classes.logoWrapper}>
                        <img
                            src="assets/img/WBSEDCL-Bhorosha-Blue-3.0.png"
                            alt="WBSEDCL Bhorosha Logo"
                        />
                        <div className={classes.notiIcon}>
                            <Tooltip title="Kindly login to view all notices (সকল বিজ্ঞপ্তি দেখতে অনুগ্রহ করে লগইন করুন।)">
                                <IconButton
                                    color="primary"
                                    className={hasNewNotice ? classes.dot : ''}
                                    onClick={() => setOpen(true)}
                                >
                                    <NotificationsIcon />
                                </IconButton>
                            </Tooltip>
                        </div>
                    </div>
                    <p>
                        <Typography component="h1" variant="h6" color="primary">
                            পেনশন পোর্টাল
                        </Typography>
                    </p>
                    <p style={{ width: "100%" }}>
                        {children}
                    </p>
                </div>
            </Grid>
            <Modal
                open={open}
                className={classes.modal}
                onClose={() => setOpen(false)}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <div className={classes.modalBody}>
                    <h2><IconButton style={{ color: "red" }} onClick={() => setOpen(false)}><ClearOutlined /></IconButton>Notices (বিজ্ঞপ্তি)</h2>
                    <hr />
                    <p style={{ textAlign: "justify" }}> {hasNewNotice ? "New Notice Available. Kindly login to view all notices." : "Kindly login to view all notices."}</p>
                    <p style={{ textAlign: "justify" }}> {hasNewNotice ? "(নতুন বিজ্ঞপ্তি পাওয়া যাচ্ছে। সকল বিজ্ঞপ্তি দেখতে অনুগ্রহ করে লগইন করুন।)" : "(সকল বিজ্ঞপ্তি দেখতে অনুগ্রহ করে লগইন করুন।)"} </p>
                    <Button variant='contained' color='primary' style={{ display: 'block', margin: '0 auto' }} onClick={() => setOpen(false)}>
                        Back (পিছনে)
                    </Button>
                </div>
            </Modal>
        </Grid>
    )
}